import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommercialComponent } from './commercial/commercial.component';
import { PartnershipComponent } from './partnership/partnership.component';
import { PlayerComponent } from './player/player.component';
import { BoundaryComponent } from './boundary/boundary.component';
import { AdvertisingComponent } from './advertising/advertising.component';
import { OfficialpartnersComponent } from './officialpartners/officialpartners.component';
import { IndiafixtureComponent } from './indiafixture/indiafixture.component';
import { HospitalityComponent } from './hospitality/hospitality.component';

const routes: Routes = [
  {path: "commercial", component: CommercialComponent},
  {path: "partnership", component: PartnershipComponent},
  {path: "players-sponsor", component: PlayerComponent},
  {path: "boundary", component: BoundaryComponent},
  {path: "advertising", component: AdvertisingComponent},
  {path: "officialpartners", component: OfficialpartnersComponent},
  {path: "indiafixture", component: IndiafixtureComponent},
  {path: "hospitality", component: HospitalityComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommercialRoutingModule { }
